import { calculateMSThreshold } from '../../calculations'
import { CardColors } from '../../styles'

export interface IgetTimerLimitsInput {
  minuteCountdown?: number
  secondsCountdown?: number
  warningThresholdPercent?: number
  criticalThresholdPercent?: number
  defaultColor?: CardColors
}

export interface IgetTimerLimits {
  warningThresholdMS: number
  criticalThresholdMS: number
  handleColorChange: (time: number) => CardColors
}

export const getTimerLimits = ({
  minuteCountdown = 0,
  secondsCountdown,
  warningThresholdPercent = 0,
  criticalThresholdPercent = 0,
  defaultColor = CardColors.gray,
}: IgetTimerLimitsInput): IgetTimerLimits => {
  const secondsToCount = secondsCountdown || minuteCountdown * 60
  const warningThresholdMS = calculateMSThreshold(
    secondsToCount,
    warningThresholdPercent
  )
  const criticalThresholdMS = calculateMSThreshold(
    secondsToCount,
    criticalThresholdPercent
  )

  const handleColorChange = (time: number) => {
    if (!warningThresholdMS || !criticalThresholdMS) return defaultColor

    if (time <= warningThresholdMS && time > criticalThresholdMS) {
      return CardColors.yellow
    }
    if (time <= criticalThresholdMS) {
      return CardColors.red
    }

    return defaultColor
  }

  return {
    warningThresholdMS,
    criticalThresholdMS,
    handleColorChange,
  }
}
